module.exports = __webpack_public_path__ + "img/Flag_of_Brunei.82577bde.svg";